import React from "react";
import { PulseLoader } from "react-spinners";

class SpinnerComponent extends React.Component {
  state = {
    loading: true,
  };
  render() {
    return (
      <div className="main-custom-loader">
      <div className="sweet-loading">
        <PulseLoader
          className="clip-loader"
          sizeUnit={"px"}
          size={15}
          color={"#7B00A3"}
          loading={this.state.loading}
        />
      </div>
      </div>
    );
  }
}

export default SpinnerComponent;
